/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as AuthAssistantRouteImport } from './routes/_auth/assistant'
import { Route as AuthHomeRouteImport } from './routes/_auth/home'
import { Route as AuthMoreRouteImport } from './routes/_auth/more'
import { Route as AuthOperationsRouteImport } from './routes/_auth/operations'
import { Route as AuthProfileRouteImport } from './routes/_auth/profile'
import { Route as AuthRostersRouteImport } from './routes/_auth/rosters'
import { Route as AuthSettingsRouteImport } from './routes/_auth/settings'
import { Route as AuthTripsRouteImport } from './routes/_auth/trips'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as AuthAircraftIndexRouteImport } from './routes/_auth/aircraft/index'
import { Route as AuthAircraftAircraftIdRouteImport } from './routes/_auth/aircraft/$aircraftId'
import { Route as AuthAirportDirectoryIndexRouteImport } from './routes/_auth/airport-directory/index'
import { Route as AuthAirportIcaoRouteImport } from './routes/_auth/airport/$icao'
import { Route as AuthConversationsIndexRouteImport } from './routes/_auth/conversations/index'
import { Route as AuthConversationsConversationIdRouteImport } from './routes/_auth/conversations/$conversationId'
import { Route as AuthConversationsArchiveRouteImport } from './routes/_auth/conversations/archive'
import { Route as AuthCrewDirectoryIndexRouteImport } from './routes/_auth/crew-directory/index'
import { Route as AuthCrewDirectoryCrewIdRouteImport } from './routes/_auth/crew-directory/$crewId'
import { Route as AuthCrewCrewIdRouteImport } from './routes/_auth/crew/$crewId'
import { Route as AuthDocumentsIndexRouteImport } from './routes/_auth/documents/index'
import { Route as AuthDocumentsDocumentIdRouteImport } from './routes/_auth/documents/$documentId'
import { Route as AuthFlightsIndexRouteImport } from './routes/_auth/flights/index'
import { Route as AuthInboxIndexRouteImport } from './routes/_auth/inbox/index'
import { Route as AuthInboxNotificationIdRouteImport } from './routes/_auth/inbox/$notificationId'
import { Route as AuthInboxArchiveRouteImport } from './routes/_auth/inbox/archive'
import { Route as AuthOperationsIndexRouteImport } from './routes/_auth/operations/index'
import { Route as AuthOperationsActivityRouteImport } from './routes/_auth/operations/activity'
import { Route as AuthOperationsAnnouncementsRouteImport } from './routes/_auth/operations/announcements'
import { Route as AuthOperationsOnboardingRouteImport } from './routes/_auth/operations/onboarding'
import { Route as AuthOperationsTripsRouteImport } from './routes/_auth/operations/trips'
import { Route as AuthPaxIndexRouteImport } from './routes/_auth/pax/index'
import { Route as AuthPaxPaxIdRouteImport } from './routes/_auth/pax/$paxId'
import { Route as AuthProfileIndexRouteImport } from './routes/_auth/profile/index'
import { Route as AuthProfileCompanyRouteImport } from './routes/_auth/profile/company'
import { Route as AuthProfileDocumentsRouteImport } from './routes/_auth/profile/documents'
import { Route as AuthProfileHelpSupportRouteImport } from './routes/_auth/profile/help-support'
import { Route as AuthProfileRosterRouteImport } from './routes/_auth/profile/roster'
import { Route as AuthProfileSettingsRouteImport } from './routes/_auth/profile/settings'
import { Route as AuthRosterCrewIdRouteImport } from './routes/_auth/roster/$crewId'
import { Route as AuthScheduleIndexRouteImport } from './routes/_auth/schedule/index'
import { Route as AuthScheduleTripIdRouteImport } from './routes/_auth/schedule/$tripId'
import { Route as AuthScheduleTripsRouteImport } from './routes/_auth/schedule/trips'
import { Route as AuthTaskIndexRouteImport } from './routes/_auth/task/index'
import { Route as AuthTaskTaskIdRouteImport } from './routes/_auth/task/$taskId'
import { Route as AuthTasksIndexRouteImport } from './routes/_auth/tasks/index'
import { Route as AuthTasksStartRouteImport } from './routes/_auth/tasks/start'
import { Route as AuthAircraftAircraftIdFlightLogsRouteImport } from './routes/_auth/aircraft/$aircraftId_.flight-logs'
import { Route as AuthOperationsAircraftIndexRouteImport } from './routes/_auth/operations/aircraft/index'
import { Route as AuthOperationsAircraftAircraftIdRouteImport } from './routes/_auth/operations/aircraft/$aircraftId'
import { Route as AuthOperationsChecklisttemplatesIndexRouteImport } from './routes/_auth/operations/checklisttemplates/index'
import { Route as AuthOperationsChecklisttemplatesNewRouteImport } from './routes/_auth/operations/checklisttemplates/new'
import { Route as AuthOperationsCrewDirectoryIndexRouteImport } from './routes/_auth/operations/crew-directory/index'
import { Route as AuthOperationsCrewDirectoryCrewIdRouteImport } from './routes/_auth/operations/crew-directory/$crewId'
import { Route as AuthOperationsDocumentsIndexRouteImport } from './routes/_auth/operations/documents/index'
import { Route as AuthOperationsPaxIndexRouteImport } from './routes/_auth/operations/pax/index'
import { Route as AuthOperationsPaxPassengerIdRouteImport } from './routes/_auth/operations/pax/$passengerId'
import { Route as AuthOperationsRostersIndexRouteImport } from './routes/_auth/operations/rosters/index'
import { Route as AuthOperationsSettingsIndexRouteImport } from './routes/_auth/operations/settings/index'
import { Route as AuthOperationsSettingsCompanyinfoRouteImport } from './routes/_auth/operations/settings/companyinfo'
import { Route as AuthOperationsSettingsOwneradminsRouteImport } from './routes/_auth/operations/settings/owneradmins'
import { Route as AuthOperationsSettingsPrivacyRouteImport } from './routes/_auth/operations/settings/privacy'
import { Route as AuthOperationsSettingsTermsRouteImport } from './routes/_auth/operations/settings/terms'
import { Route as AuthOperationsSubscriptionsIndexRouteImport } from './routes/_auth/operations/subscriptions/index'
import { Route as AuthOperationsTripsIndexRouteImport } from './routes/_auth/operations/trips/index'
import { Route as AuthOperationsTripsTripIdRouteImport } from './routes/_auth/operations/trips/$tripId'
import { Route as AuthProfileSettingsIndexRouteImport } from './routes/_auth/profile/settings/index'
import { Route as AuthProfileSettingsAppearanceRouteImport } from './routes/_auth/profile/settings/appearance'
import { Route as AuthProfileSettingsHelpandsupportRouteImport } from './routes/_auth/profile/settings/helpandsupport'
import { Route as AuthProfileSettingsNotificationsRouteImport } from './routes/_auth/profile/settings/notifications'
import { Route as AuthProfileSettingsPasscodeRouteImport } from './routes/_auth/profile/settings/passcode'
import { Route as AuthProfileSettingsRegionalRouteImport } from './routes/_auth/profile/settings/regional'
import { Route as AuthOperationsChecklisttemplatesEditChecklistIdRouteImport } from './routes/_auth/operations/checklisttemplates/edit/$checklistId'
import { Route as AuthOperationsChecklisttemplatesPreviewChecklistIdRouteImport } from './routes/_auth/operations/checklisttemplates/preview/$checklistId'
import { Route as AuthOperationsTasksArchivedIndexRouteImport } from './routes/_auth/operations/tasks/archived/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAssistantRoute = AuthAssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHomeRoute = AuthHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMoreRoute = AuthMoreRouteImport.update({
  id: '/more',
  path: '/more',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOperationsRoute = AuthOperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfileRoute = AuthProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRostersRoute = AuthRostersRouteImport.update({
  id: '/rosters',
  path: '/rosters',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTripsRoute = AuthTripsRouteImport.update({
  id: '/trips',
  path: '/trips',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAircraftIndexRoute = AuthAircraftIndexRouteImport.update({
  id: '/aircraft/',
  path: '/aircraft/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAircraftAircraftIdRoute = AuthAircraftAircraftIdRouteImport.update({
  id: '/aircraft/$aircraftId',
  path: '/aircraft/$aircraftId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAirportDirectoryIndexRoute =
  AuthAirportDirectoryIndexRouteImport.update({
    id: '/airport-directory/',
    path: '/airport-directory/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAirportIcaoRoute = AuthAirportIcaoRouteImport.update({
  id: '/airport/$icao',
  path: '/airport/$icao',
  getParentRoute: () => AuthRoute,
} as any)
const AuthConversationsIndexRoute = AuthConversationsIndexRouteImport.update({
  id: '/conversations/',
  path: '/conversations/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthConversationsConversationIdRoute =
  AuthConversationsConversationIdRouteImport.update({
    id: '/conversations/$conversationId',
    path: '/conversations/$conversationId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthConversationsArchiveRoute =
  AuthConversationsArchiveRouteImport.update({
    id: '/conversations/archive',
    path: '/conversations/archive',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthCrewDirectoryIndexRoute = AuthCrewDirectoryIndexRouteImport.update({
  id: '/crew-directory/',
  path: '/crew-directory/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCrewDirectoryCrewIdRoute = AuthCrewDirectoryCrewIdRouteImport.update({
  id: '/crew-directory/$crewId',
  path: '/crew-directory/$crewId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCrewCrewIdRoute = AuthCrewCrewIdRouteImport.update({
  id: '/crew/$crewId',
  path: '/crew/$crewId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDocumentsIndexRoute = AuthDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDocumentsDocumentIdRoute = AuthDocumentsDocumentIdRouteImport.update({
  id: '/documents/$documentId',
  path: '/documents/$documentId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFlightsIndexRoute = AuthFlightsIndexRouteImport.update({
  id: '/flights/',
  path: '/flights/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInboxIndexRoute = AuthInboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInboxNotificationIdRoute = AuthInboxNotificationIdRouteImport.update({
  id: '/inbox/$notificationId',
  path: '/inbox/$notificationId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInboxArchiveRoute = AuthInboxArchiveRouteImport.update({
  id: '/inbox/archive',
  path: '/inbox/archive',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOperationsIndexRoute = AuthOperationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOperationsRoute,
} as any)
const AuthOperationsActivityRoute = AuthOperationsActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AuthOperationsRoute,
} as any)
const AuthOperationsAnnouncementsRoute =
  AuthOperationsAnnouncementsRouteImport.update({
    id: '/announcements',
    path: '/announcements',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsOnboardingRoute =
  AuthOperationsOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsTripsRoute = AuthOperationsTripsRouteImport.update({
  id: '/trips',
  path: '/trips',
  getParentRoute: () => AuthOperationsRoute,
} as any)
const AuthPaxIndexRoute = AuthPaxIndexRouteImport.update({
  id: '/pax/',
  path: '/pax/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPaxPaxIdRoute = AuthPaxPaxIdRouteImport.update({
  id: '/pax/$paxId',
  path: '/pax/$paxId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfileIndexRoute = AuthProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthProfileRoute,
} as any)
const AuthProfileCompanyRoute = AuthProfileCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => AuthProfileRoute,
} as any)
const AuthProfileDocumentsRoute = AuthProfileDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AuthProfileRoute,
} as any)
const AuthProfileHelpSupportRoute = AuthProfileHelpSupportRouteImport.update({
  id: '/help-support',
  path: '/help-support',
  getParentRoute: () => AuthProfileRoute,
} as any)
const AuthProfileRosterRoute = AuthProfileRosterRouteImport.update({
  id: '/roster',
  path: '/roster',
  getParentRoute: () => AuthProfileRoute,
} as any)
const AuthProfileSettingsRoute = AuthProfileSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthProfileRoute,
} as any)
const AuthRosterCrewIdRoute = AuthRosterCrewIdRouteImport.update({
  id: '/roster/$crewId',
  path: '/roster/$crewId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScheduleIndexRoute = AuthScheduleIndexRouteImport.update({
  id: '/schedule/',
  path: '/schedule/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScheduleTripIdRoute = AuthScheduleTripIdRouteImport.update({
  id: '/schedule/$tripId',
  path: '/schedule/$tripId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScheduleTripsRoute = AuthScheduleTripsRouteImport.update({
  id: '/schedule/trips',
  path: '/schedule/trips',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTaskIndexRoute = AuthTaskIndexRouteImport.update({
  id: '/task/',
  path: '/task/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTaskTaskIdRoute = AuthTaskTaskIdRouteImport.update({
  id: '/task/$taskId',
  path: '/task/$taskId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTasksIndexRoute = AuthTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTasksStartRoute = AuthTasksStartRouteImport.update({
  id: '/tasks/start',
  path: '/tasks/start',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAircraftAircraftIdFlightLogsRoute =
  AuthAircraftAircraftIdFlightLogsRouteImport.update({
    id: '/aircraft/$aircraftId_/flight-logs',
    path: '/aircraft/$aircraftId/flight-logs',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthOperationsAircraftIndexRoute =
  AuthOperationsAircraftIndexRouteImport.update({
    id: '/aircraft/',
    path: '/aircraft/',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsAircraftAircraftIdRoute =
  AuthOperationsAircraftAircraftIdRouteImport.update({
    id: '/aircraft/$aircraftId',
    path: '/aircraft/$aircraftId',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsChecklisttemplatesIndexRoute =
  AuthOperationsChecklisttemplatesIndexRouteImport.update({
    id: '/checklisttemplates/',
    path: '/checklisttemplates/',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsChecklisttemplatesNewRoute =
  AuthOperationsChecklisttemplatesNewRouteImport.update({
    id: '/checklisttemplates/new',
    path: '/checklisttemplates/new',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsCrewDirectoryIndexRoute =
  AuthOperationsCrewDirectoryIndexRouteImport.update({
    id: '/crew-directory/',
    path: '/crew-directory/',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsCrewDirectoryCrewIdRoute =
  AuthOperationsCrewDirectoryCrewIdRouteImport.update({
    id: '/crew-directory/$crewId',
    path: '/crew-directory/$crewId',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsDocumentsIndexRoute =
  AuthOperationsDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsPaxIndexRoute = AuthOperationsPaxIndexRouteImport.update({
  id: '/pax/',
  path: '/pax/',
  getParentRoute: () => AuthOperationsRoute,
} as any)
const AuthOperationsPaxPassengerIdRoute =
  AuthOperationsPaxPassengerIdRouteImport.update({
    id: '/pax/$passengerId',
    path: '/pax/$passengerId',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsRostersIndexRoute =
  AuthOperationsRostersIndexRouteImport.update({
    id: '/rosters/',
    path: '/rosters/',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsSettingsIndexRoute =
  AuthOperationsSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsSettingsCompanyinfoRoute =
  AuthOperationsSettingsCompanyinfoRouteImport.update({
    id: '/settings/companyinfo',
    path: '/settings/companyinfo',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsSettingsOwneradminsRoute =
  AuthOperationsSettingsOwneradminsRouteImport.update({
    id: '/settings/owneradmins',
    path: '/settings/owneradmins',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsSettingsPrivacyRoute =
  AuthOperationsSettingsPrivacyRouteImport.update({
    id: '/settings/privacy',
    path: '/settings/privacy',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsSettingsTermsRoute =
  AuthOperationsSettingsTermsRouteImport.update({
    id: '/settings/terms',
    path: '/settings/terms',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsSubscriptionsIndexRoute =
  AuthOperationsSubscriptionsIndexRouteImport.update({
    id: '/subscriptions/',
    path: '/subscriptions/',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsTripsIndexRoute =
  AuthOperationsTripsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOperationsTripsRoute,
  } as any)
const AuthOperationsTripsTripIdRoute =
  AuthOperationsTripsTripIdRouteImport.update({
    id: '/$tripId',
    path: '/$tripId',
    getParentRoute: () => AuthOperationsTripsRoute,
  } as any)
const AuthProfileSettingsIndexRoute =
  AuthProfileSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthProfileSettingsRoute,
  } as any)
const AuthProfileSettingsAppearanceRoute =
  AuthProfileSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthProfileSettingsRoute,
  } as any)
const AuthProfileSettingsHelpandsupportRoute =
  AuthProfileSettingsHelpandsupportRouteImport.update({
    id: '/helpandsupport',
    path: '/helpandsupport',
    getParentRoute: () => AuthProfileSettingsRoute,
  } as any)
const AuthProfileSettingsNotificationsRoute =
  AuthProfileSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthProfileSettingsRoute,
  } as any)
const AuthProfileSettingsPasscodeRoute =
  AuthProfileSettingsPasscodeRouteImport.update({
    id: '/passcode',
    path: '/passcode',
    getParentRoute: () => AuthProfileSettingsRoute,
  } as any)
const AuthProfileSettingsRegionalRoute =
  AuthProfileSettingsRegionalRouteImport.update({
    id: '/regional',
    path: '/regional',
    getParentRoute: () => AuthProfileSettingsRoute,
  } as any)
const AuthOperationsChecklisttemplatesEditChecklistIdRoute =
  AuthOperationsChecklisttemplatesEditChecklistIdRouteImport.update({
    id: '/checklisttemplates/edit/$checklistId',
    path: '/checklisttemplates/edit/$checklistId',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsChecklisttemplatesPreviewChecklistIdRoute =
  AuthOperationsChecklisttemplatesPreviewChecklistIdRouteImport.update({
    id: '/checklisttemplates/preview/$checklistId',
    path: '/checklisttemplates/preview/$checklistId',
    getParentRoute: () => AuthOperationsRoute,
  } as any)
const AuthOperationsTasksArchivedIndexRoute =
  AuthOperationsTasksArchivedIndexRouteImport.update({
    id: '/tasks/archived/',
    path: '/tasks/archived/',
    getParentRoute: () => AuthOperationsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/signin': typeof SigninRoute
  '/assistant': typeof AuthAssistantRoute
  '/home': typeof AuthHomeRoute
  '/more': typeof AuthMoreRoute
  '/operations': typeof AuthOperationsRouteWithChildren
  '/profile': typeof AuthProfileRouteWithChildren
  '/rosters': typeof AuthRostersRoute
  '/settings': typeof AuthSettingsRoute
  '/trips': typeof AuthTripsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/aircraft/$aircraftId': typeof AuthAircraftAircraftIdRoute
  '/airport/$icao': typeof AuthAirportIcaoRoute
  '/conversations/$conversationId': typeof AuthConversationsConversationIdRoute
  '/conversations/archive': typeof AuthConversationsArchiveRoute
  '/crew-directory/$crewId': typeof AuthCrewDirectoryCrewIdRoute
  '/crew/$crewId': typeof AuthCrewCrewIdRoute
  '/documents/$documentId': typeof AuthDocumentsDocumentIdRoute
  '/inbox/$notificationId': typeof AuthInboxNotificationIdRoute
  '/inbox/archive': typeof AuthInboxArchiveRoute
  '/operations/activity': typeof AuthOperationsActivityRoute
  '/operations/announcements': typeof AuthOperationsAnnouncementsRoute
  '/operations/onboarding': typeof AuthOperationsOnboardingRoute
  '/operations/trips': typeof AuthOperationsTripsRouteWithChildren
  '/pax/$paxId': typeof AuthPaxPaxIdRoute
  '/profile/company': typeof AuthProfileCompanyRoute
  '/profile/documents': typeof AuthProfileDocumentsRoute
  '/profile/help-support': typeof AuthProfileHelpSupportRoute
  '/profile/roster': typeof AuthProfileRosterRoute
  '/profile/settings': typeof AuthProfileSettingsRouteWithChildren
  '/roster/$crewId': typeof AuthRosterCrewIdRoute
  '/schedule/$tripId': typeof AuthScheduleTripIdRoute
  '/schedule/trips': typeof AuthScheduleTripsRoute
  '/task/$taskId': typeof AuthTaskTaskIdRoute
  '/tasks/start': typeof AuthTasksStartRoute
  '/aircraft/': typeof AuthAircraftIndexRoute
  '/airport-directory/': typeof AuthAirportDirectoryIndexRoute
  '/conversations/': typeof AuthConversationsIndexRoute
  '/crew-directory/': typeof AuthCrewDirectoryIndexRoute
  '/documents/': typeof AuthDocumentsIndexRoute
  '/flights/': typeof AuthFlightsIndexRoute
  '/inbox/': typeof AuthInboxIndexRoute
  '/operations/': typeof AuthOperationsIndexRoute
  '/pax/': typeof AuthPaxIndexRoute
  '/profile/': typeof AuthProfileIndexRoute
  '/schedule/': typeof AuthScheduleIndexRoute
  '/task/': typeof AuthTaskIndexRoute
  '/tasks/': typeof AuthTasksIndexRoute
  '/aircraft/$aircraftId/flight-logs': typeof AuthAircraftAircraftIdFlightLogsRoute
  '/operations/aircraft/$aircraftId': typeof AuthOperationsAircraftAircraftIdRoute
  '/operations/checklisttemplates/new': typeof AuthOperationsChecklisttemplatesNewRoute
  '/operations/crew-directory/$crewId': typeof AuthOperationsCrewDirectoryCrewIdRoute
  '/operations/pax/$passengerId': typeof AuthOperationsPaxPassengerIdRoute
  '/operations/settings/companyinfo': typeof AuthOperationsSettingsCompanyinfoRoute
  '/operations/settings/owneradmins': typeof AuthOperationsSettingsOwneradminsRoute
  '/operations/settings/privacy': typeof AuthOperationsSettingsPrivacyRoute
  '/operations/settings/terms': typeof AuthOperationsSettingsTermsRoute
  '/operations/trips/$tripId': typeof AuthOperationsTripsTripIdRoute
  '/profile/settings/appearance': typeof AuthProfileSettingsAppearanceRoute
  '/profile/settings/helpandsupport': typeof AuthProfileSettingsHelpandsupportRoute
  '/profile/settings/notifications': typeof AuthProfileSettingsNotificationsRoute
  '/profile/settings/passcode': typeof AuthProfileSettingsPasscodeRoute
  '/profile/settings/regional': typeof AuthProfileSettingsRegionalRoute
  '/operations/aircraft/': typeof AuthOperationsAircraftIndexRoute
  '/operations/checklisttemplates/': typeof AuthOperationsChecklisttemplatesIndexRoute
  '/operations/crew-directory/': typeof AuthOperationsCrewDirectoryIndexRoute
  '/operations/documents/': typeof AuthOperationsDocumentsIndexRoute
  '/operations/pax/': typeof AuthOperationsPaxIndexRoute
  '/operations/rosters/': typeof AuthOperationsRostersIndexRoute
  '/operations/settings/': typeof AuthOperationsSettingsIndexRoute
  '/operations/subscriptions/': typeof AuthOperationsSubscriptionsIndexRoute
  '/operations/trips/': typeof AuthOperationsTripsIndexRoute
  '/profile/settings/': typeof AuthProfileSettingsIndexRoute
  '/operations/checklisttemplates/edit/$checklistId': typeof AuthOperationsChecklisttemplatesEditChecklistIdRoute
  '/operations/checklisttemplates/preview/$checklistId': typeof AuthOperationsChecklisttemplatesPreviewChecklistIdRoute
  '/operations/tasks/archived/': typeof AuthOperationsTasksArchivedIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/signin': typeof SigninRoute
  '/assistant': typeof AuthAssistantRoute
  '/home': typeof AuthHomeRoute
  '/more': typeof AuthMoreRoute
  '/rosters': typeof AuthRostersRoute
  '/settings': typeof AuthSettingsRoute
  '/trips': typeof AuthTripsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/aircraft/$aircraftId': typeof AuthAircraftAircraftIdRoute
  '/airport/$icao': typeof AuthAirportIcaoRoute
  '/conversations/$conversationId': typeof AuthConversationsConversationIdRoute
  '/conversations/archive': typeof AuthConversationsArchiveRoute
  '/crew-directory/$crewId': typeof AuthCrewDirectoryCrewIdRoute
  '/crew/$crewId': typeof AuthCrewCrewIdRoute
  '/documents/$documentId': typeof AuthDocumentsDocumentIdRoute
  '/inbox/$notificationId': typeof AuthInboxNotificationIdRoute
  '/inbox/archive': typeof AuthInboxArchiveRoute
  '/operations/activity': typeof AuthOperationsActivityRoute
  '/operations/announcements': typeof AuthOperationsAnnouncementsRoute
  '/operations/onboarding': typeof AuthOperationsOnboardingRoute
  '/pax/$paxId': typeof AuthPaxPaxIdRoute
  '/profile/company': typeof AuthProfileCompanyRoute
  '/profile/documents': typeof AuthProfileDocumentsRoute
  '/profile/help-support': typeof AuthProfileHelpSupportRoute
  '/profile/roster': typeof AuthProfileRosterRoute
  '/roster/$crewId': typeof AuthRosterCrewIdRoute
  '/schedule/$tripId': typeof AuthScheduleTripIdRoute
  '/schedule/trips': typeof AuthScheduleTripsRoute
  '/task/$taskId': typeof AuthTaskTaskIdRoute
  '/tasks/start': typeof AuthTasksStartRoute
  '/aircraft': typeof AuthAircraftIndexRoute
  '/airport-directory': typeof AuthAirportDirectoryIndexRoute
  '/conversations': typeof AuthConversationsIndexRoute
  '/crew-directory': typeof AuthCrewDirectoryIndexRoute
  '/documents': typeof AuthDocumentsIndexRoute
  '/flights': typeof AuthFlightsIndexRoute
  '/inbox': typeof AuthInboxIndexRoute
  '/operations': typeof AuthOperationsIndexRoute
  '/pax': typeof AuthPaxIndexRoute
  '/profile': typeof AuthProfileIndexRoute
  '/schedule': typeof AuthScheduleIndexRoute
  '/task': typeof AuthTaskIndexRoute
  '/tasks': typeof AuthTasksIndexRoute
  '/aircraft/$aircraftId/flight-logs': typeof AuthAircraftAircraftIdFlightLogsRoute
  '/operations/aircraft/$aircraftId': typeof AuthOperationsAircraftAircraftIdRoute
  '/operations/checklisttemplates/new': typeof AuthOperationsChecklisttemplatesNewRoute
  '/operations/crew-directory/$crewId': typeof AuthOperationsCrewDirectoryCrewIdRoute
  '/operations/pax/$passengerId': typeof AuthOperationsPaxPassengerIdRoute
  '/operations/settings/companyinfo': typeof AuthOperationsSettingsCompanyinfoRoute
  '/operations/settings/owneradmins': typeof AuthOperationsSettingsOwneradminsRoute
  '/operations/settings/privacy': typeof AuthOperationsSettingsPrivacyRoute
  '/operations/settings/terms': typeof AuthOperationsSettingsTermsRoute
  '/operations/trips/$tripId': typeof AuthOperationsTripsTripIdRoute
  '/profile/settings/appearance': typeof AuthProfileSettingsAppearanceRoute
  '/profile/settings/helpandsupport': typeof AuthProfileSettingsHelpandsupportRoute
  '/profile/settings/notifications': typeof AuthProfileSettingsNotificationsRoute
  '/profile/settings/passcode': typeof AuthProfileSettingsPasscodeRoute
  '/profile/settings/regional': typeof AuthProfileSettingsRegionalRoute
  '/operations/aircraft': typeof AuthOperationsAircraftIndexRoute
  '/operations/checklisttemplates': typeof AuthOperationsChecklisttemplatesIndexRoute
  '/operations/crew-directory': typeof AuthOperationsCrewDirectoryIndexRoute
  '/operations/documents': typeof AuthOperationsDocumentsIndexRoute
  '/operations/pax': typeof AuthOperationsPaxIndexRoute
  '/operations/rosters': typeof AuthOperationsRostersIndexRoute
  '/operations/settings': typeof AuthOperationsSettingsIndexRoute
  '/operations/subscriptions': typeof AuthOperationsSubscriptionsIndexRoute
  '/operations/trips': typeof AuthOperationsTripsIndexRoute
  '/profile/settings': typeof AuthProfileSettingsIndexRoute
  '/operations/checklisttemplates/edit/$checklistId': typeof AuthOperationsChecklisttemplatesEditChecklistIdRoute
  '/operations/checklisttemplates/preview/$checklistId': typeof AuthOperationsChecklisttemplatesPreviewChecklistIdRoute
  '/operations/tasks/archived': typeof AuthOperationsTasksArchivedIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/signin': typeof SigninRoute
  '/_auth/assistant': typeof AuthAssistantRoute
  '/_auth/home': typeof AuthHomeRoute
  '/_auth/more': typeof AuthMoreRoute
  '/_auth/operations': typeof AuthOperationsRouteWithChildren
  '/_auth/profile': typeof AuthProfileRouteWithChildren
  '/_auth/rosters': typeof AuthRostersRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/trips': typeof AuthTripsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/_auth/aircraft/$aircraftId': typeof AuthAircraftAircraftIdRoute
  '/_auth/airport/$icao': typeof AuthAirportIcaoRoute
  '/_auth/conversations/$conversationId': typeof AuthConversationsConversationIdRoute
  '/_auth/conversations/archive': typeof AuthConversationsArchiveRoute
  '/_auth/crew-directory/$crewId': typeof AuthCrewDirectoryCrewIdRoute
  '/_auth/crew/$crewId': typeof AuthCrewCrewIdRoute
  '/_auth/documents/$documentId': typeof AuthDocumentsDocumentIdRoute
  '/_auth/inbox/$notificationId': typeof AuthInboxNotificationIdRoute
  '/_auth/inbox/archive': typeof AuthInboxArchiveRoute
  '/_auth/operations/activity': typeof AuthOperationsActivityRoute
  '/_auth/operations/announcements': typeof AuthOperationsAnnouncementsRoute
  '/_auth/operations/onboarding': typeof AuthOperationsOnboardingRoute
  '/_auth/operations/trips': typeof AuthOperationsTripsRouteWithChildren
  '/_auth/pax/$paxId': typeof AuthPaxPaxIdRoute
  '/_auth/profile/company': typeof AuthProfileCompanyRoute
  '/_auth/profile/documents': typeof AuthProfileDocumentsRoute
  '/_auth/profile/help-support': typeof AuthProfileHelpSupportRoute
  '/_auth/profile/roster': typeof AuthProfileRosterRoute
  '/_auth/profile/settings': typeof AuthProfileSettingsRouteWithChildren
  '/_auth/roster/$crewId': typeof AuthRosterCrewIdRoute
  '/_auth/schedule/$tripId': typeof AuthScheduleTripIdRoute
  '/_auth/schedule/trips': typeof AuthScheduleTripsRoute
  '/_auth/task/$taskId': typeof AuthTaskTaskIdRoute
  '/_auth/tasks/start': typeof AuthTasksStartRoute
  '/_auth/aircraft/': typeof AuthAircraftIndexRoute
  '/_auth/airport-directory/': typeof AuthAirportDirectoryIndexRoute
  '/_auth/conversations/': typeof AuthConversationsIndexRoute
  '/_auth/crew-directory/': typeof AuthCrewDirectoryIndexRoute
  '/_auth/documents/': typeof AuthDocumentsIndexRoute
  '/_auth/flights/': typeof AuthFlightsIndexRoute
  '/_auth/inbox/': typeof AuthInboxIndexRoute
  '/_auth/operations/': typeof AuthOperationsIndexRoute
  '/_auth/pax/': typeof AuthPaxIndexRoute
  '/_auth/profile/': typeof AuthProfileIndexRoute
  '/_auth/schedule/': typeof AuthScheduleIndexRoute
  '/_auth/task/': typeof AuthTaskIndexRoute
  '/_auth/tasks/': typeof AuthTasksIndexRoute
  '/_auth/aircraft/$aircraftId_/flight-logs': typeof AuthAircraftAircraftIdFlightLogsRoute
  '/_auth/operations/aircraft/$aircraftId': typeof AuthOperationsAircraftAircraftIdRoute
  '/_auth/operations/checklisttemplates/new': typeof AuthOperationsChecklisttemplatesNewRoute
  '/_auth/operations/crew-directory/$crewId': typeof AuthOperationsCrewDirectoryCrewIdRoute
  '/_auth/operations/pax/$passengerId': typeof AuthOperationsPaxPassengerIdRoute
  '/_auth/operations/settings/companyinfo': typeof AuthOperationsSettingsCompanyinfoRoute
  '/_auth/operations/settings/owneradmins': typeof AuthOperationsSettingsOwneradminsRoute
  '/_auth/operations/settings/privacy': typeof AuthOperationsSettingsPrivacyRoute
  '/_auth/operations/settings/terms': typeof AuthOperationsSettingsTermsRoute
  '/_auth/operations/trips/$tripId': typeof AuthOperationsTripsTripIdRoute
  '/_auth/profile/settings/appearance': typeof AuthProfileSettingsAppearanceRoute
  '/_auth/profile/settings/helpandsupport': typeof AuthProfileSettingsHelpandsupportRoute
  '/_auth/profile/settings/notifications': typeof AuthProfileSettingsNotificationsRoute
  '/_auth/profile/settings/passcode': typeof AuthProfileSettingsPasscodeRoute
  '/_auth/profile/settings/regional': typeof AuthProfileSettingsRegionalRoute
  '/_auth/operations/aircraft/': typeof AuthOperationsAircraftIndexRoute
  '/_auth/operations/checklisttemplates/': typeof AuthOperationsChecklisttemplatesIndexRoute
  '/_auth/operations/crew-directory/': typeof AuthOperationsCrewDirectoryIndexRoute
  '/_auth/operations/documents/': typeof AuthOperationsDocumentsIndexRoute
  '/_auth/operations/pax/': typeof AuthOperationsPaxIndexRoute
  '/_auth/operations/rosters/': typeof AuthOperationsRostersIndexRoute
  '/_auth/operations/settings/': typeof AuthOperationsSettingsIndexRoute
  '/_auth/operations/subscriptions/': typeof AuthOperationsSubscriptionsIndexRoute
  '/_auth/operations/trips/': typeof AuthOperationsTripsIndexRoute
  '/_auth/profile/settings/': typeof AuthProfileSettingsIndexRoute
  '/_auth/operations/checklisttemplates/edit/$checklistId': typeof AuthOperationsChecklisttemplatesEditChecklistIdRoute
  '/_auth/operations/checklisttemplates/preview/$checklistId': typeof AuthOperationsChecklisttemplatesPreviewChecklistIdRoute
  '/_auth/operations/tasks/archived/': typeof AuthOperationsTasksArchivedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/signin'
    | '/assistant'
    | '/home'
    | '/more'
    | '/operations'
    | '/profile'
    | '/rosters'
    | '/settings'
    | '/trips'
    | '/auth/callback'
    | '/oauth/consent'
    | '/aircraft/$aircraftId'
    | '/airport/$icao'
    | '/conversations/$conversationId'
    | '/conversations/archive'
    | '/crew-directory/$crewId'
    | '/crew/$crewId'
    | '/documents/$documentId'
    | '/inbox/$notificationId'
    | '/inbox/archive'
    | '/operations/activity'
    | '/operations/announcements'
    | '/operations/onboarding'
    | '/operations/trips'
    | '/pax/$paxId'
    | '/profile/company'
    | '/profile/documents'
    | '/profile/help-support'
    | '/profile/roster'
    | '/profile/settings'
    | '/roster/$crewId'
    | '/schedule/$tripId'
    | '/schedule/trips'
    | '/task/$taskId'
    | '/tasks/start'
    | '/aircraft/'
    | '/airport-directory/'
    | '/conversations/'
    | '/crew-directory/'
    | '/documents/'
    | '/flights/'
    | '/inbox/'
    | '/operations/'
    | '/pax/'
    | '/profile/'
    | '/schedule/'
    | '/task/'
    | '/tasks/'
    | '/aircraft/$aircraftId/flight-logs'
    | '/operations/aircraft/$aircraftId'
    | '/operations/checklisttemplates/new'
    | '/operations/crew-directory/$crewId'
    | '/operations/pax/$passengerId'
    | '/operations/settings/companyinfo'
    | '/operations/settings/owneradmins'
    | '/operations/settings/privacy'
    | '/operations/settings/terms'
    | '/operations/trips/$tripId'
    | '/profile/settings/appearance'
    | '/profile/settings/helpandsupport'
    | '/profile/settings/notifications'
    | '/profile/settings/passcode'
    | '/profile/settings/regional'
    | '/operations/aircraft/'
    | '/operations/checklisttemplates/'
    | '/operations/crew-directory/'
    | '/operations/documents/'
    | '/operations/pax/'
    | '/operations/rosters/'
    | '/operations/settings/'
    | '/operations/subscriptions/'
    | '/operations/trips/'
    | '/profile/settings/'
    | '/operations/checklisttemplates/edit/$checklistId'
    | '/operations/checklisttemplates/preview/$checklistId'
    | '/operations/tasks/archived/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/signin'
    | '/assistant'
    | '/home'
    | '/more'
    | '/rosters'
    | '/settings'
    | '/trips'
    | '/auth/callback'
    | '/oauth/consent'
    | '/aircraft/$aircraftId'
    | '/airport/$icao'
    | '/conversations/$conversationId'
    | '/conversations/archive'
    | '/crew-directory/$crewId'
    | '/crew/$crewId'
    | '/documents/$documentId'
    | '/inbox/$notificationId'
    | '/inbox/archive'
    | '/operations/activity'
    | '/operations/announcements'
    | '/operations/onboarding'
    | '/pax/$paxId'
    | '/profile/company'
    | '/profile/documents'
    | '/profile/help-support'
    | '/profile/roster'
    | '/roster/$crewId'
    | '/schedule/$tripId'
    | '/schedule/trips'
    | '/task/$taskId'
    | '/tasks/start'
    | '/aircraft'
    | '/airport-directory'
    | '/conversations'
    | '/crew-directory'
    | '/documents'
    | '/flights'
    | '/inbox'
    | '/operations'
    | '/pax'
    | '/profile'
    | '/schedule'
    | '/task'
    | '/tasks'
    | '/aircraft/$aircraftId/flight-logs'
    | '/operations/aircraft/$aircraftId'
    | '/operations/checklisttemplates/new'
    | '/operations/crew-directory/$crewId'
    | '/operations/pax/$passengerId'
    | '/operations/settings/companyinfo'
    | '/operations/settings/owneradmins'
    | '/operations/settings/privacy'
    | '/operations/settings/terms'
    | '/operations/trips/$tripId'
    | '/profile/settings/appearance'
    | '/profile/settings/helpandsupport'
    | '/profile/settings/notifications'
    | '/profile/settings/passcode'
    | '/profile/settings/regional'
    | '/operations/aircraft'
    | '/operations/checklisttemplates'
    | '/operations/crew-directory'
    | '/operations/documents'
    | '/operations/pax'
    | '/operations/rosters'
    | '/operations/settings'
    | '/operations/subscriptions'
    | '/operations/trips'
    | '/profile/settings'
    | '/operations/checklisttemplates/edit/$checklistId'
    | '/operations/checklisttemplates/preview/$checklistId'
    | '/operations/tasks/archived'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/onboarding'
    | '/signin'
    | '/_auth/assistant'
    | '/_auth/home'
    | '/_auth/more'
    | '/_auth/operations'
    | '/_auth/profile'
    | '/_auth/rosters'
    | '/_auth/settings'
    | '/_auth/trips'
    | '/auth/callback'
    | '/oauth/consent'
    | '/_auth/aircraft/$aircraftId'
    | '/_auth/airport/$icao'
    | '/_auth/conversations/$conversationId'
    | '/_auth/conversations/archive'
    | '/_auth/crew-directory/$crewId'
    | '/_auth/crew/$crewId'
    | '/_auth/documents/$documentId'
    | '/_auth/inbox/$notificationId'
    | '/_auth/inbox/archive'
    | '/_auth/operations/activity'
    | '/_auth/operations/announcements'
    | '/_auth/operations/onboarding'
    | '/_auth/operations/trips'
    | '/_auth/pax/$paxId'
    | '/_auth/profile/company'
    | '/_auth/profile/documents'
    | '/_auth/profile/help-support'
    | '/_auth/profile/roster'
    | '/_auth/profile/settings'
    | '/_auth/roster/$crewId'
    | '/_auth/schedule/$tripId'
    | '/_auth/schedule/trips'
    | '/_auth/task/$taskId'
    | '/_auth/tasks/start'
    | '/_auth/aircraft/'
    | '/_auth/airport-directory/'
    | '/_auth/conversations/'
    | '/_auth/crew-directory/'
    | '/_auth/documents/'
    | '/_auth/flights/'
    | '/_auth/inbox/'
    | '/_auth/operations/'
    | '/_auth/pax/'
    | '/_auth/profile/'
    | '/_auth/schedule/'
    | '/_auth/task/'
    | '/_auth/tasks/'
    | '/_auth/aircraft/$aircraftId_/flight-logs'
    | '/_auth/operations/aircraft/$aircraftId'
    | '/_auth/operations/checklisttemplates/new'
    | '/_auth/operations/crew-directory/$crewId'
    | '/_auth/operations/pax/$passengerId'
    | '/_auth/operations/settings/companyinfo'
    | '/_auth/operations/settings/owneradmins'
    | '/_auth/operations/settings/privacy'
    | '/_auth/operations/settings/terms'
    | '/_auth/operations/trips/$tripId'
    | '/_auth/profile/settings/appearance'
    | '/_auth/profile/settings/helpandsupport'
    | '/_auth/profile/settings/notifications'
    | '/_auth/profile/settings/passcode'
    | '/_auth/profile/settings/regional'
    | '/_auth/operations/aircraft/'
    | '/_auth/operations/checklisttemplates/'
    | '/_auth/operations/crew-directory/'
    | '/_auth/operations/documents/'
    | '/_auth/operations/pax/'
    | '/_auth/operations/rosters/'
    | '/_auth/operations/settings/'
    | '/_auth/operations/subscriptions/'
    | '/_auth/operations/trips/'
    | '/_auth/profile/settings/'
    | '/_auth/operations/checklisttemplates/edit/$checklistId'
    | '/_auth/operations/checklisttemplates/preview/$checklistId'
    | '/_auth/operations/tasks/archived/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
  SigninRoute: typeof SigninRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  OauthConsentRoute: typeof OauthConsentRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/assistant': {
      id: '/_auth/assistant'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof AuthAssistantRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/home': {
      id: '/_auth/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthHomeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/more': {
      id: '/_auth/more'
      path: '/more'
      fullPath: '/more'
      preLoaderRoute: typeof AuthMoreRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/operations': {
      id: '/_auth/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof AuthOperationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/profile': {
      id: '/_auth/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/rosters': {
      id: '/_auth/rosters'
      path: '/rosters'
      fullPath: '/rosters'
      preLoaderRoute: typeof AuthRostersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/trips': {
      id: '/_auth/trips'
      path: '/trips'
      fullPath: '/trips'
      preLoaderRoute: typeof AuthTripsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/aircraft/': {
      id: '/_auth/aircraft/'
      path: '/aircraft'
      fullPath: '/aircraft/'
      preLoaderRoute: typeof AuthAircraftIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/aircraft/$aircraftId': {
      id: '/_auth/aircraft/$aircraftId'
      path: '/aircraft/$aircraftId'
      fullPath: '/aircraft/$aircraftId'
      preLoaderRoute: typeof AuthAircraftAircraftIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/airport-directory/': {
      id: '/_auth/airport-directory/'
      path: '/airport-directory'
      fullPath: '/airport-directory/'
      preLoaderRoute: typeof AuthAirportDirectoryIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/airport/$icao': {
      id: '/_auth/airport/$icao'
      path: '/airport/$icao'
      fullPath: '/airport/$icao'
      preLoaderRoute: typeof AuthAirportIcaoRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/conversations/': {
      id: '/_auth/conversations/'
      path: '/conversations'
      fullPath: '/conversations/'
      preLoaderRoute: typeof AuthConversationsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/conversations/$conversationId': {
      id: '/_auth/conversations/$conversationId'
      path: '/conversations/$conversationId'
      fullPath: '/conversations/$conversationId'
      preLoaderRoute: typeof AuthConversationsConversationIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/conversations/archive': {
      id: '/_auth/conversations/archive'
      path: '/conversations/archive'
      fullPath: '/conversations/archive'
      preLoaderRoute: typeof AuthConversationsArchiveRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/crew-directory/': {
      id: '/_auth/crew-directory/'
      path: '/crew-directory'
      fullPath: '/crew-directory/'
      preLoaderRoute: typeof AuthCrewDirectoryIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/crew-directory/$crewId': {
      id: '/_auth/crew-directory/$crewId'
      path: '/crew-directory/$crewId'
      fullPath: '/crew-directory/$crewId'
      preLoaderRoute: typeof AuthCrewDirectoryCrewIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/crew/$crewId': {
      id: '/_auth/crew/$crewId'
      path: '/crew/$crewId'
      fullPath: '/crew/$crewId'
      preLoaderRoute: typeof AuthCrewCrewIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/documents/': {
      id: '/_auth/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthDocumentsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/documents/$documentId': {
      id: '/_auth/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/documents/$documentId'
      preLoaderRoute: typeof AuthDocumentsDocumentIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/flights/': {
      id: '/_auth/flights/'
      path: '/flights'
      fullPath: '/flights/'
      preLoaderRoute: typeof AuthFlightsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inbox/': {
      id: '/_auth/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof AuthInboxIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inbox/$notificationId': {
      id: '/_auth/inbox/$notificationId'
      path: '/inbox/$notificationId'
      fullPath: '/inbox/$notificationId'
      preLoaderRoute: typeof AuthInboxNotificationIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inbox/archive': {
      id: '/_auth/inbox/archive'
      path: '/inbox/archive'
      fullPath: '/inbox/archive'
      preLoaderRoute: typeof AuthInboxArchiveRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/operations/': {
      id: '/_auth/operations/'
      path: '/'
      fullPath: '/operations/'
      preLoaderRoute: typeof AuthOperationsIndexRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/activity': {
      id: '/_auth/operations/activity'
      path: '/activity'
      fullPath: '/operations/activity'
      preLoaderRoute: typeof AuthOperationsActivityRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/announcements': {
      id: '/_auth/operations/announcements'
      path: '/announcements'
      fullPath: '/operations/announcements'
      preLoaderRoute: typeof AuthOperationsAnnouncementsRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/onboarding': {
      id: '/_auth/operations/onboarding'
      path: '/onboarding'
      fullPath: '/operations/onboarding'
      preLoaderRoute: typeof AuthOperationsOnboardingRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/trips': {
      id: '/_auth/operations/trips'
      path: '/trips'
      fullPath: '/operations/trips'
      preLoaderRoute: typeof AuthOperationsTripsRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/pax/': {
      id: '/_auth/pax/'
      path: '/pax'
      fullPath: '/pax/'
      preLoaderRoute: typeof AuthPaxIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/pax/$paxId': {
      id: '/_auth/pax/$paxId'
      path: '/pax/$paxId'
      fullPath: '/pax/$paxId'
      preLoaderRoute: typeof AuthPaxPaxIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/profile/': {
      id: '/_auth/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthProfileIndexRouteImport
      parentRoute: typeof AuthProfileRoute
    }
    '/_auth/profile/company': {
      id: '/_auth/profile/company'
      path: '/company'
      fullPath: '/profile/company'
      preLoaderRoute: typeof AuthProfileCompanyRouteImport
      parentRoute: typeof AuthProfileRoute
    }
    '/_auth/profile/documents': {
      id: '/_auth/profile/documents'
      path: '/documents'
      fullPath: '/profile/documents'
      preLoaderRoute: typeof AuthProfileDocumentsRouteImport
      parentRoute: typeof AuthProfileRoute
    }
    '/_auth/profile/help-support': {
      id: '/_auth/profile/help-support'
      path: '/help-support'
      fullPath: '/profile/help-support'
      preLoaderRoute: typeof AuthProfileHelpSupportRouteImport
      parentRoute: typeof AuthProfileRoute
    }
    '/_auth/profile/roster': {
      id: '/_auth/profile/roster'
      path: '/roster'
      fullPath: '/profile/roster'
      preLoaderRoute: typeof AuthProfileRosterRouteImport
      parentRoute: typeof AuthProfileRoute
    }
    '/_auth/profile/settings': {
      id: '/_auth/profile/settings'
      path: '/settings'
      fullPath: '/profile/settings'
      preLoaderRoute: typeof AuthProfileSettingsRouteImport
      parentRoute: typeof AuthProfileRoute
    }
    '/_auth/roster/$crewId': {
      id: '/_auth/roster/$crewId'
      path: '/roster/$crewId'
      fullPath: '/roster/$crewId'
      preLoaderRoute: typeof AuthRosterCrewIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/schedule/': {
      id: '/_auth/schedule/'
      path: '/schedule'
      fullPath: '/schedule/'
      preLoaderRoute: typeof AuthScheduleIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/schedule/$tripId': {
      id: '/_auth/schedule/$tripId'
      path: '/schedule/$tripId'
      fullPath: '/schedule/$tripId'
      preLoaderRoute: typeof AuthScheduleTripIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/schedule/trips': {
      id: '/_auth/schedule/trips'
      path: '/schedule/trips'
      fullPath: '/schedule/trips'
      preLoaderRoute: typeof AuthScheduleTripsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/task/': {
      id: '/_auth/task/'
      path: '/task'
      fullPath: '/task/'
      preLoaderRoute: typeof AuthTaskIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/task/$taskId': {
      id: '/_auth/task/$taskId'
      path: '/task/$taskId'
      fullPath: '/task/$taskId'
      preLoaderRoute: typeof AuthTaskTaskIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tasks/': {
      id: '/_auth/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthTasksIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tasks/start': {
      id: '/_auth/tasks/start'
      path: '/tasks/start'
      fullPath: '/tasks/start'
      preLoaderRoute: typeof AuthTasksStartRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/aircraft/$aircraftId_/flight-logs': {
      id: '/_auth/aircraft/$aircraftId_/flight-logs'
      path: '/aircraft/$aircraftId/flight-logs'
      fullPath: '/aircraft/$aircraftId/flight-logs'
      preLoaderRoute: typeof AuthAircraftAircraftIdFlightLogsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/operations/aircraft/': {
      id: '/_auth/operations/aircraft/'
      path: '/aircraft'
      fullPath: '/operations/aircraft/'
      preLoaderRoute: typeof AuthOperationsAircraftIndexRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/aircraft/$aircraftId': {
      id: '/_auth/operations/aircraft/$aircraftId'
      path: '/aircraft/$aircraftId'
      fullPath: '/operations/aircraft/$aircraftId'
      preLoaderRoute: typeof AuthOperationsAircraftAircraftIdRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/checklisttemplates/': {
      id: '/_auth/operations/checklisttemplates/'
      path: '/checklisttemplates'
      fullPath: '/operations/checklisttemplates/'
      preLoaderRoute: typeof AuthOperationsChecklisttemplatesIndexRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/checklisttemplates/new': {
      id: '/_auth/operations/checklisttemplates/new'
      path: '/checklisttemplates/new'
      fullPath: '/operations/checklisttemplates/new'
      preLoaderRoute: typeof AuthOperationsChecklisttemplatesNewRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/crew-directory/': {
      id: '/_auth/operations/crew-directory/'
      path: '/crew-directory'
      fullPath: '/operations/crew-directory/'
      preLoaderRoute: typeof AuthOperationsCrewDirectoryIndexRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/crew-directory/$crewId': {
      id: '/_auth/operations/crew-directory/$crewId'
      path: '/crew-directory/$crewId'
      fullPath: '/operations/crew-directory/$crewId'
      preLoaderRoute: typeof AuthOperationsCrewDirectoryCrewIdRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/documents/': {
      id: '/_auth/operations/documents/'
      path: '/documents'
      fullPath: '/operations/documents/'
      preLoaderRoute: typeof AuthOperationsDocumentsIndexRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/pax/': {
      id: '/_auth/operations/pax/'
      path: '/pax'
      fullPath: '/operations/pax/'
      preLoaderRoute: typeof AuthOperationsPaxIndexRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/pax/$passengerId': {
      id: '/_auth/operations/pax/$passengerId'
      path: '/pax/$passengerId'
      fullPath: '/operations/pax/$passengerId'
      preLoaderRoute: typeof AuthOperationsPaxPassengerIdRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/rosters/': {
      id: '/_auth/operations/rosters/'
      path: '/rosters'
      fullPath: '/operations/rosters/'
      preLoaderRoute: typeof AuthOperationsRostersIndexRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/settings/': {
      id: '/_auth/operations/settings/'
      path: '/settings'
      fullPath: '/operations/settings/'
      preLoaderRoute: typeof AuthOperationsSettingsIndexRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/settings/companyinfo': {
      id: '/_auth/operations/settings/companyinfo'
      path: '/settings/companyinfo'
      fullPath: '/operations/settings/companyinfo'
      preLoaderRoute: typeof AuthOperationsSettingsCompanyinfoRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/settings/owneradmins': {
      id: '/_auth/operations/settings/owneradmins'
      path: '/settings/owneradmins'
      fullPath: '/operations/settings/owneradmins'
      preLoaderRoute: typeof AuthOperationsSettingsOwneradminsRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/settings/privacy': {
      id: '/_auth/operations/settings/privacy'
      path: '/settings/privacy'
      fullPath: '/operations/settings/privacy'
      preLoaderRoute: typeof AuthOperationsSettingsPrivacyRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/settings/terms': {
      id: '/_auth/operations/settings/terms'
      path: '/settings/terms'
      fullPath: '/operations/settings/terms'
      preLoaderRoute: typeof AuthOperationsSettingsTermsRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/subscriptions/': {
      id: '/_auth/operations/subscriptions/'
      path: '/subscriptions'
      fullPath: '/operations/subscriptions/'
      preLoaderRoute: typeof AuthOperationsSubscriptionsIndexRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/trips/': {
      id: '/_auth/operations/trips/'
      path: '/'
      fullPath: '/operations/trips/'
      preLoaderRoute: typeof AuthOperationsTripsIndexRouteImport
      parentRoute: typeof AuthOperationsTripsRoute
    }
    '/_auth/operations/trips/$tripId': {
      id: '/_auth/operations/trips/$tripId'
      path: '/$tripId'
      fullPath: '/operations/trips/$tripId'
      preLoaderRoute: typeof AuthOperationsTripsTripIdRouteImport
      parentRoute: typeof AuthOperationsTripsRoute
    }
    '/_auth/profile/settings/': {
      id: '/_auth/profile/settings/'
      path: '/'
      fullPath: '/profile/settings/'
      preLoaderRoute: typeof AuthProfileSettingsIndexRouteImport
      parentRoute: typeof AuthProfileSettingsRoute
    }
    '/_auth/profile/settings/appearance': {
      id: '/_auth/profile/settings/appearance'
      path: '/appearance'
      fullPath: '/profile/settings/appearance'
      preLoaderRoute: typeof AuthProfileSettingsAppearanceRouteImport
      parentRoute: typeof AuthProfileSettingsRoute
    }
    '/_auth/profile/settings/helpandsupport': {
      id: '/_auth/profile/settings/helpandsupport'
      path: '/helpandsupport'
      fullPath: '/profile/settings/helpandsupport'
      preLoaderRoute: typeof AuthProfileSettingsHelpandsupportRouteImport
      parentRoute: typeof AuthProfileSettingsRoute
    }
    '/_auth/profile/settings/notifications': {
      id: '/_auth/profile/settings/notifications'
      path: '/notifications'
      fullPath: '/profile/settings/notifications'
      preLoaderRoute: typeof AuthProfileSettingsNotificationsRouteImport
      parentRoute: typeof AuthProfileSettingsRoute
    }
    '/_auth/profile/settings/passcode': {
      id: '/_auth/profile/settings/passcode'
      path: '/passcode'
      fullPath: '/profile/settings/passcode'
      preLoaderRoute: typeof AuthProfileSettingsPasscodeRouteImport
      parentRoute: typeof AuthProfileSettingsRoute
    }
    '/_auth/profile/settings/regional': {
      id: '/_auth/profile/settings/regional'
      path: '/regional'
      fullPath: '/profile/settings/regional'
      preLoaderRoute: typeof AuthProfileSettingsRegionalRouteImport
      parentRoute: typeof AuthProfileSettingsRoute
    }
    '/_auth/operations/checklisttemplates/edit/$checklistId': {
      id: '/_auth/operations/checklisttemplates/edit/$checklistId'
      path: '/checklisttemplates/edit/$checklistId'
      fullPath: '/operations/checklisttemplates/edit/$checklistId'
      preLoaderRoute: typeof AuthOperationsChecklisttemplatesEditChecklistIdRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/checklisttemplates/preview/$checklistId': {
      id: '/_auth/operations/checklisttemplates/preview/$checklistId'
      path: '/checklisttemplates/preview/$checklistId'
      fullPath: '/operations/checklisttemplates/preview/$checklistId'
      preLoaderRoute: typeof AuthOperationsChecklisttemplatesPreviewChecklistIdRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
    '/_auth/operations/tasks/archived/': {
      id: '/_auth/operations/tasks/archived/'
      path: '/tasks/archived'
      fullPath: '/operations/tasks/archived/'
      preLoaderRoute: typeof AuthOperationsTasksArchivedIndexRouteImport
      parentRoute: typeof AuthOperationsRoute
    }
  }
}

interface AuthOperationsTripsRouteChildren {
  AuthOperationsTripsTripIdRoute: typeof AuthOperationsTripsTripIdRoute
  AuthOperationsTripsIndexRoute: typeof AuthOperationsTripsIndexRoute
}

const AuthOperationsTripsRouteChildren: AuthOperationsTripsRouteChildren = {
  AuthOperationsTripsTripIdRoute: AuthOperationsTripsTripIdRoute,
  AuthOperationsTripsIndexRoute: AuthOperationsTripsIndexRoute,
}

const AuthOperationsTripsRouteWithChildren =
  AuthOperationsTripsRoute._addFileChildren(AuthOperationsTripsRouteChildren)

interface AuthOperationsRouteChildren {
  AuthOperationsActivityRoute: typeof AuthOperationsActivityRoute
  AuthOperationsAnnouncementsRoute: typeof AuthOperationsAnnouncementsRoute
  AuthOperationsOnboardingRoute: typeof AuthOperationsOnboardingRoute
  AuthOperationsTripsRoute: typeof AuthOperationsTripsRouteWithChildren
  AuthOperationsIndexRoute: typeof AuthOperationsIndexRoute
  AuthOperationsAircraftAircraftIdRoute: typeof AuthOperationsAircraftAircraftIdRoute
  AuthOperationsChecklisttemplatesNewRoute: typeof AuthOperationsChecklisttemplatesNewRoute
  AuthOperationsCrewDirectoryCrewIdRoute: typeof AuthOperationsCrewDirectoryCrewIdRoute
  AuthOperationsPaxPassengerIdRoute: typeof AuthOperationsPaxPassengerIdRoute
  AuthOperationsSettingsCompanyinfoRoute: typeof AuthOperationsSettingsCompanyinfoRoute
  AuthOperationsSettingsOwneradminsRoute: typeof AuthOperationsSettingsOwneradminsRoute
  AuthOperationsSettingsPrivacyRoute: typeof AuthOperationsSettingsPrivacyRoute
  AuthOperationsSettingsTermsRoute: typeof AuthOperationsSettingsTermsRoute
  AuthOperationsAircraftIndexRoute: typeof AuthOperationsAircraftIndexRoute
  AuthOperationsChecklisttemplatesIndexRoute: typeof AuthOperationsChecklisttemplatesIndexRoute
  AuthOperationsCrewDirectoryIndexRoute: typeof AuthOperationsCrewDirectoryIndexRoute
  AuthOperationsDocumentsIndexRoute: typeof AuthOperationsDocumentsIndexRoute
  AuthOperationsPaxIndexRoute: typeof AuthOperationsPaxIndexRoute
  AuthOperationsRostersIndexRoute: typeof AuthOperationsRostersIndexRoute
  AuthOperationsSettingsIndexRoute: typeof AuthOperationsSettingsIndexRoute
  AuthOperationsSubscriptionsIndexRoute: typeof AuthOperationsSubscriptionsIndexRoute
  AuthOperationsChecklisttemplatesEditChecklistIdRoute: typeof AuthOperationsChecklisttemplatesEditChecklistIdRoute
  AuthOperationsChecklisttemplatesPreviewChecklistIdRoute: typeof AuthOperationsChecklisttemplatesPreviewChecklistIdRoute
  AuthOperationsTasksArchivedIndexRoute: typeof AuthOperationsTasksArchivedIndexRoute
}

const AuthOperationsRouteChildren: AuthOperationsRouteChildren = {
  AuthOperationsActivityRoute: AuthOperationsActivityRoute,
  AuthOperationsAnnouncementsRoute: AuthOperationsAnnouncementsRoute,
  AuthOperationsOnboardingRoute: AuthOperationsOnboardingRoute,
  AuthOperationsTripsRoute: AuthOperationsTripsRouteWithChildren,
  AuthOperationsIndexRoute: AuthOperationsIndexRoute,
  AuthOperationsAircraftAircraftIdRoute: AuthOperationsAircraftAircraftIdRoute,
  AuthOperationsChecklisttemplatesNewRoute:
    AuthOperationsChecklisttemplatesNewRoute,
  AuthOperationsCrewDirectoryCrewIdRoute:
    AuthOperationsCrewDirectoryCrewIdRoute,
  AuthOperationsPaxPassengerIdRoute: AuthOperationsPaxPassengerIdRoute,
  AuthOperationsSettingsCompanyinfoRoute:
    AuthOperationsSettingsCompanyinfoRoute,
  AuthOperationsSettingsOwneradminsRoute:
    AuthOperationsSettingsOwneradminsRoute,
  AuthOperationsSettingsPrivacyRoute: AuthOperationsSettingsPrivacyRoute,
  AuthOperationsSettingsTermsRoute: AuthOperationsSettingsTermsRoute,
  AuthOperationsAircraftIndexRoute: AuthOperationsAircraftIndexRoute,
  AuthOperationsChecklisttemplatesIndexRoute:
    AuthOperationsChecklisttemplatesIndexRoute,
  AuthOperationsCrewDirectoryIndexRoute: AuthOperationsCrewDirectoryIndexRoute,
  AuthOperationsDocumentsIndexRoute: AuthOperationsDocumentsIndexRoute,
  AuthOperationsPaxIndexRoute: AuthOperationsPaxIndexRoute,
  AuthOperationsRostersIndexRoute: AuthOperationsRostersIndexRoute,
  AuthOperationsSettingsIndexRoute: AuthOperationsSettingsIndexRoute,
  AuthOperationsSubscriptionsIndexRoute: AuthOperationsSubscriptionsIndexRoute,
  AuthOperationsChecklisttemplatesEditChecklistIdRoute:
    AuthOperationsChecklisttemplatesEditChecklistIdRoute,
  AuthOperationsChecklisttemplatesPreviewChecklistIdRoute:
    AuthOperationsChecklisttemplatesPreviewChecklistIdRoute,
  AuthOperationsTasksArchivedIndexRoute: AuthOperationsTasksArchivedIndexRoute,
}

const AuthOperationsRouteWithChildren = AuthOperationsRoute._addFileChildren(
  AuthOperationsRouteChildren,
)

interface AuthProfileSettingsRouteChildren {
  AuthProfileSettingsAppearanceRoute: typeof AuthProfileSettingsAppearanceRoute
  AuthProfileSettingsHelpandsupportRoute: typeof AuthProfileSettingsHelpandsupportRoute
  AuthProfileSettingsNotificationsRoute: typeof AuthProfileSettingsNotificationsRoute
  AuthProfileSettingsPasscodeRoute: typeof AuthProfileSettingsPasscodeRoute
  AuthProfileSettingsRegionalRoute: typeof AuthProfileSettingsRegionalRoute
  AuthProfileSettingsIndexRoute: typeof AuthProfileSettingsIndexRoute
}

const AuthProfileSettingsRouteChildren: AuthProfileSettingsRouteChildren = {
  AuthProfileSettingsAppearanceRoute: AuthProfileSettingsAppearanceRoute,
  AuthProfileSettingsHelpandsupportRoute:
    AuthProfileSettingsHelpandsupportRoute,
  AuthProfileSettingsNotificationsRoute: AuthProfileSettingsNotificationsRoute,
  AuthProfileSettingsPasscodeRoute: AuthProfileSettingsPasscodeRoute,
  AuthProfileSettingsRegionalRoute: AuthProfileSettingsRegionalRoute,
  AuthProfileSettingsIndexRoute: AuthProfileSettingsIndexRoute,
}

const AuthProfileSettingsRouteWithChildren =
  AuthProfileSettingsRoute._addFileChildren(AuthProfileSettingsRouteChildren)

interface AuthProfileRouteChildren {
  AuthProfileCompanyRoute: typeof AuthProfileCompanyRoute
  AuthProfileDocumentsRoute: typeof AuthProfileDocumentsRoute
  AuthProfileHelpSupportRoute: typeof AuthProfileHelpSupportRoute
  AuthProfileRosterRoute: typeof AuthProfileRosterRoute
  AuthProfileSettingsRoute: typeof AuthProfileSettingsRouteWithChildren
  AuthProfileIndexRoute: typeof AuthProfileIndexRoute
}

const AuthProfileRouteChildren: AuthProfileRouteChildren = {
  AuthProfileCompanyRoute: AuthProfileCompanyRoute,
  AuthProfileDocumentsRoute: AuthProfileDocumentsRoute,
  AuthProfileHelpSupportRoute: AuthProfileHelpSupportRoute,
  AuthProfileRosterRoute: AuthProfileRosterRoute,
  AuthProfileSettingsRoute: AuthProfileSettingsRouteWithChildren,
  AuthProfileIndexRoute: AuthProfileIndexRoute,
}

const AuthProfileRouteWithChildren = AuthProfileRoute._addFileChildren(
  AuthProfileRouteChildren,
)

interface AuthRouteChildren {
  AuthAssistantRoute: typeof AuthAssistantRoute
  AuthHomeRoute: typeof AuthHomeRoute
  AuthMoreRoute: typeof AuthMoreRoute
  AuthOperationsRoute: typeof AuthOperationsRouteWithChildren
  AuthProfileRoute: typeof AuthProfileRouteWithChildren
  AuthRostersRoute: typeof AuthRostersRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthTripsRoute: typeof AuthTripsRoute
  AuthAircraftAircraftIdRoute: typeof AuthAircraftAircraftIdRoute
  AuthAirportIcaoRoute: typeof AuthAirportIcaoRoute
  AuthConversationsConversationIdRoute: typeof AuthConversationsConversationIdRoute
  AuthConversationsArchiveRoute: typeof AuthConversationsArchiveRoute
  AuthCrewDirectoryCrewIdRoute: typeof AuthCrewDirectoryCrewIdRoute
  AuthCrewCrewIdRoute: typeof AuthCrewCrewIdRoute
  AuthDocumentsDocumentIdRoute: typeof AuthDocumentsDocumentIdRoute
  AuthInboxNotificationIdRoute: typeof AuthInboxNotificationIdRoute
  AuthInboxArchiveRoute: typeof AuthInboxArchiveRoute
  AuthPaxPaxIdRoute: typeof AuthPaxPaxIdRoute
  AuthRosterCrewIdRoute: typeof AuthRosterCrewIdRoute
  AuthScheduleTripIdRoute: typeof AuthScheduleTripIdRoute
  AuthScheduleTripsRoute: typeof AuthScheduleTripsRoute
  AuthTaskTaskIdRoute: typeof AuthTaskTaskIdRoute
  AuthTasksStartRoute: typeof AuthTasksStartRoute
  AuthAircraftIndexRoute: typeof AuthAircraftIndexRoute
  AuthAirportDirectoryIndexRoute: typeof AuthAirportDirectoryIndexRoute
  AuthConversationsIndexRoute: typeof AuthConversationsIndexRoute
  AuthCrewDirectoryIndexRoute: typeof AuthCrewDirectoryIndexRoute
  AuthDocumentsIndexRoute: typeof AuthDocumentsIndexRoute
  AuthFlightsIndexRoute: typeof AuthFlightsIndexRoute
  AuthInboxIndexRoute: typeof AuthInboxIndexRoute
  AuthPaxIndexRoute: typeof AuthPaxIndexRoute
  AuthScheduleIndexRoute: typeof AuthScheduleIndexRoute
  AuthTaskIndexRoute: typeof AuthTaskIndexRoute
  AuthTasksIndexRoute: typeof AuthTasksIndexRoute
  AuthAircraftAircraftIdFlightLogsRoute: typeof AuthAircraftAircraftIdFlightLogsRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAssistantRoute: AuthAssistantRoute,
  AuthHomeRoute: AuthHomeRoute,
  AuthMoreRoute: AuthMoreRoute,
  AuthOperationsRoute: AuthOperationsRouteWithChildren,
  AuthProfileRoute: AuthProfileRouteWithChildren,
  AuthRostersRoute: AuthRostersRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthTripsRoute: AuthTripsRoute,
  AuthAircraftAircraftIdRoute: AuthAircraftAircraftIdRoute,
  AuthAirportIcaoRoute: AuthAirportIcaoRoute,
  AuthConversationsConversationIdRoute: AuthConversationsConversationIdRoute,
  AuthConversationsArchiveRoute: AuthConversationsArchiveRoute,
  AuthCrewDirectoryCrewIdRoute: AuthCrewDirectoryCrewIdRoute,
  AuthCrewCrewIdRoute: AuthCrewCrewIdRoute,
  AuthDocumentsDocumentIdRoute: AuthDocumentsDocumentIdRoute,
  AuthInboxNotificationIdRoute: AuthInboxNotificationIdRoute,
  AuthInboxArchiveRoute: AuthInboxArchiveRoute,
  AuthPaxPaxIdRoute: AuthPaxPaxIdRoute,
  AuthRosterCrewIdRoute: AuthRosterCrewIdRoute,
  AuthScheduleTripIdRoute: AuthScheduleTripIdRoute,
  AuthScheduleTripsRoute: AuthScheduleTripsRoute,
  AuthTaskTaskIdRoute: AuthTaskTaskIdRoute,
  AuthTasksStartRoute: AuthTasksStartRoute,
  AuthAircraftIndexRoute: AuthAircraftIndexRoute,
  AuthAirportDirectoryIndexRoute: AuthAirportDirectoryIndexRoute,
  AuthConversationsIndexRoute: AuthConversationsIndexRoute,
  AuthCrewDirectoryIndexRoute: AuthCrewDirectoryIndexRoute,
  AuthDocumentsIndexRoute: AuthDocumentsIndexRoute,
  AuthFlightsIndexRoute: AuthFlightsIndexRoute,
  AuthInboxIndexRoute: AuthInboxIndexRoute,
  AuthPaxIndexRoute: AuthPaxIndexRoute,
  AuthScheduleIndexRoute: AuthScheduleIndexRoute,
  AuthTaskIndexRoute: AuthTaskIndexRoute,
  AuthTasksIndexRoute: AuthTasksIndexRoute,
  AuthAircraftAircraftIdFlightLogsRoute: AuthAircraftAircraftIdFlightLogsRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
  SigninRoute: SigninRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  OauthConsentRoute: OauthConsentRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
